module.exports = __webpack_public_path__ + "img/simon_zsuzsi_c80_A3-03.a9b4f9dc.jpg";